(function ($) {
  "use strict";
  $(function () {

    $(document).on('click', '[data-action="section-promo-close"]', function () {
      let id = $(this).data('entity');
      let data = new FormData();
      data.append('action', 'hide');
      data.append('id', id);
      $.ajax({
        method: 'POST',
        url: '/ajax/hidePromo.php',
        data: data,
        cache: false,
        contentType: false,
        processData: false,
        dataType: 'json',
        success: function () {
          let promo = $(document).find('.promo-slide-' + id);
          promo.fadeOut(250, function () {
            promo.remove();
            $(document).find('[data-entity="section-promo"]').slick('unslick');
            $(document).find('[data-entity="section-promo"]').slick({
              autoplay: true,
              speed: 1500,
              adaptiveHeight: false,
              arrows: true,
              dots: true,
              prevArrow: $(document).find('.sectionbanner__prev'),
              nextArrow: $(document).find('.sectionbanner__next'),
            });
          })
        },
        error: function (data) {
          console.log(data);
        }
      });

    })
  })
})(jQuery);
